import { MySquid, User } from '@hub/shared'

const blockedEmails = ['hfyuoiakom_1634747033@tfbnw.net']

interface Args {
  configs: MySquid | null | undefined
  user: User | null
}

export const showInsights = ({ configs, user }: Args) => {
  return !configs?._id && user?.profileadditionalinfo?.email && !blockedEmails.includes(user.profileadditionalinfo.email)
}
